'use strict'

import SearchAutocomplete from '@ui/Search/Form/Fields/Autocomplete/component'
import dataLayer, { DataLayer } from 'assets/core/js/module/dataLayer'
import { EventType as DataLayerSearchEventType, push as dataLayerSearchPush } from 'assets/core/js/module/searchForm/dataLayer/search'

import type { SearchAutocomplete as SearchAutocompleteType } from '@ui/Search/Form/Fields/Autocomplete/component'

const dataLayerClick = (link: HTMLElement): void => {
  let data = null
  const rawData = link.getAttribute('data-datalayer-click')
  if (rawData !== null) {
    data = JSON.parse<DataLayer>(rawData)
  }
  if (data === null) {
    return
  }

  dataLayer.pushInLayer(window.coreGtmId, data)
}

const mapDataLayerSearchEventType = (type: string): DataLayerSearchEventType => {
  switch (type) {
    case 'brand':
      return DataLayerSearchEventType.BRAND
    case 'product':
      return DataLayerSearchEventType.PRODUCT
    default:
      return DataLayerSearchEventType.UNKNOWN
  }
}

export default function (): SearchAutocompleteType | void {
  const fieldEl = document.querySelector<HTMLElement>('#search-offers .search-form-autocomplete')

  if (!fieldEl) {
    return
  }

  const autocomplete = SearchAutocomplete(fieldEl, {
    callbackSearchSuggestionClick: (link: HTMLElement): void => {
      dataLayerClick(link)
      dataLayerSearchPush({
        type: DataLayerSearchEventType.SUGGESTION,
        term: link.textContent?.trim() ?? '',
        user_term: '',
        suggested_date: false,
        checkin: null,
        flexible: false,
        guests: '',
        night: 0,
      })
    },
    callbackLinkClick: (type: string, value: string, userInput: string): void => {
      dataLayerSearchPush({
        type: mapDataLayerSearchEventType(type),
        term: value,
        user_term: userInput,
        suggested_date: false,
        checkin: null,
        flexible: false,
        guests: '',
        night: 0,
      })
    },
  })

  return autocomplete
}
